<template>
  <b-form-group>
    <template v-slot:label>
      <span>{{ label }}</span>
      <span class="text-danger">*</span>
    </template>

    <v-select
      :id="id"
      v-model="selectedValue"
      :options="options"
      :reduce="(option) => option[attribute]"
      :clearable="false"
      :label="optionLabel"
      @input="update"
    >
      <template #selected-option="option">
        {{ truncateMiddle(option[optionLabel], 25) }}
      </template>
    </v-select>
  </b-form-group>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: { vSelect },
  props: {
    label: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: null,
    },
    attribute: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    optionLabel: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      courseId: this.$route.params.courseId,
      selectedValue: this.value,
    };
  },
  computed: {
    ...mapGetters("CourseManagement", [
      "isLoading",
      "courseInfo",
      "courseAttributeUpdated",
    ]),
  },
  watch: {
    value(newVal) {
      this.selectedValue = newVal;
    },
    options(newOptions) {
      if (newOptions.length > 0) {
        this.selectedValue = this.value;
      }
    },
  },
  methods: {
    ...mapActions("CourseManagement", [
      "updateCourseAcademic",
      "getCourseInfo",
    ]),
    async update() {
      let params = {
        courseId: this.courseId,
        attribute: {
          [this.attribute]: Number(this.selectedValue),
        },
      };
      await this.updateCourseAcademic(params);
      this.getCourseInfo({
        courseId: this.courseId,
        temp: true,
        excepts: "numberOfStudent,numberOfActiveStudent",
      });
    },
    truncateMiddle(text, startChars = 4) {
      if (!text) return "";
      const textStr = String(text);
      if (textStr.length <= startChars) {
        return textStr;
      }
      const start = textStr.substring(0, startChars);
      return `${start}...`;
    },
  },
};
</script>

<style>
.vs__dropdown-toggle {
  padding: 5px 4px;
}
.vs__search,
.vs__search:focus {
  border: 0px solid transparent;
}
</style>
